/* global axios */
import ApiClient from '../ApiClient';

class AiAgentBrains extends ApiClient {
  constructor() {
    super('ai_agents/brains', { accountScoped: true });
  }

  update(id, { draftConfig, lockVersion }) {
    return axios.patch(`${this.url}/${id}`, {
      brain: {
        draft_config: draftConfig,
        lock_version: lockVersion,
      },
    });
  }

  publish(id, changeNotes) {
    return axios.post(`${this.url}/${id}/publish`, {
      change_notes: changeNotes,
    });
  }

  killSwitch(id) {
    return axios.post(`${this.url}/${id}/kill_switch`);
  }

  activity(id) {
    return axios.get(`${this.url}/${id}/activity`);
  }

  playground(id, { message, history }) {
    return axios.post(`${this.url}/${id}/playground`, { message, history });
  }

  // Per-agent Anthropic key — stored backend-side as a connector, not in the
  // brain draft. Write-only: the API never returns the key, only the
  // `model_key_configured` boolean.
  setModelKey(id, apiKey) {
    return axios.put(`${this.url}/${id}/model_key`, { api_key: apiKey });
  }

  clearModelKey(id) {
    return axios.delete(`${this.url}/${id}/model_key`);
  }

  hire({ source, handle, name }) {
    return axios.post(`${this.baseUrl()}/ai_agents/hire`, {
      source,
      handle,
      name,
    });
  }
}

export default new AiAgentBrains();
